import { APP_VERSION } from "@/constants/normal";
import { detectStandalone } from "@/hooks/pwa/useIsPwa";
import { setHasBeenUpdated, setVersion } from "@/stores/useVersionStore";

const key = "[PWA]";

export const checkVersion: () => Promise<boolean> = async () => {
  const isPwa = detectStandalone();
  const localVersion = APP_VERSION;

  if (!isPwa) {
    setVersion(localVersion);
    return false;
  }

  const response = await fetch(`/version.json?t=${Date.now()}`, {
    cache: "no-cache",
    headers: {
      "Cache-Control": "no-cache, no-store, must-revalidate",
      Pragma: "no-cache",
      Expires: "0",
    },
  });

  if (!response.ok) {
    console.warn(`${key} Failed to fetch version info:`, response.status);
    return false;
  }

  const remoteVersionData = await response.json();
  const remoteVersion = remoteVersionData.version;
  setVersion(remoteVersion);

  return localVersion !== remoteVersion;
};

export const updatePwa: () => Promise<void> = async () => {
  const isPwa = detectStandalone();

  if (!isPwa) return;

  try {
    if ("caches" in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
    }

    if ("serviceWorker" in navigator) {
      const registration = await navigator.serviceWorker.getRegistration();
      if (registration) {
        await registration.update();
        if (registration.waiting) registration.waiting.postMessage({ type: "SKIP_WAITING" });
      }
    }

    setTimeout(() => {
      setHasBeenUpdated(true);
      window.location.reload();
    }, 200);
  } catch (error) {
    console.warn(`${key} Update failed:`, error);
    window.location.reload();
  }
};

export const initPwa: () => Promise<void> = async () => {
  const isPwa = detectStandalone();

  if (!isPwa) return;

  try {
    const hasUpdate = await checkVersion();
    if (hasUpdate) await updatePwa();
  } catch (error) {
    console.warn(`${key} Initialization failed:`, error);
  }
};
